import userEduInfoConfig from '../../account/my-info/user-edu/info-config'

export default {
  ...userEduInfoConfig,
  // 'company': {
  //   'key': 'company',
  //   'name': '所在企业',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'job_title': {
  //   'key': 'job_title',
  //   'name': '职位',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'job_title_content': {
  //   'key': 'job_title_content',
  //   'name': '',
  //   'subName': '请填写您的职位名称 (选填）',
  //   'required': false
  // },
  // 'company_industry': {
  //   'key': 'company_industry',
  //   'name': '行业领域',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'company_type': {
  //   'key': 'company_type',
  //   'name': '融资阶段',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'company_scale': {
  //   'key': 'company_scale',
  //   'name': '企业规模（人数）',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'company_remark': {
  //   'key': 'company_remark',
  //   'name': '备注',
  //   'layout': 'compaction'
  // },
  // 'company_develop': {
  //   'key': 'company_develop',
  //   'name': '企业研发团队规模（人数）',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'managed_team_size': {
  //   'key': 'managed_team_size',
  //   'name': '本人现带领团队规模（人数）',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'development_team_size': {
  //   'key': 'development_team_size',
  //   'name': '本人曾带领团队最大规模（人数）',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'developed_start_year': {
  //   'key': 'developed_start_year',
  //   'name': '从事研发工作起始年',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'managed_start_year': {
  //   'key': 'managed_start_year',
  //   'name': '从事管理工作起始年',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'study_experience': {
  //   'key': 'study_experience',
  //   'name': '教育经历',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'work_experience': {
  //   'key': 'work_experience',
  //   'name': '工作经历',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'support_resource': {
  //   'key': 'support_resource',
  //   'name': '可提供的资源',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'want_resource': {
  //   'key': 'want_resource',
  //   'name': '期望获得的价值',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 'achievements': {
  //   'key': 'achievements',
  //   'name': '项目经历',
  //   'required': true,
  //   'regName': 'checkIsEmpty'
  // },
  // 期望加入的分会
  'willingness_to_participate': {
    'key': 'willingness_to_participate',
    'name': '是否愿意参与、组织学员交流活动',
    'subTitle': 'TGO 鲲鹏会是学员共建组织，“投入越多，收获越多”我们希望所有学员能够参与其中',
    'type': 'checkbox',
    'required': true,
    'labels': [
      { 'id': 'w1', 'value': 1, 'name': '愿意参与小组活动（约4小时／每月）' },
      { 'id': 'w2', 'value': 2, 'name': '愿意担任小组组长／纪律委员／财务委员（约3小时／月）' },
      { 'id': 'w3', 'value': 3, 'name': '愿意将来担任董事会岗位（约10小时／月）' },
      { 'id': 'w4', 'value': 4, 'name': '时间不好确定，到时再说' }
    ],
    'regName': 'checkIsEmpty'
  }
}
